

















import { roundToNDecimalPlaces } from "@dcc/common/rounding";
export default {
  props: {
    fromQuantity: {
      type: Number,
      required: true
    },
    toQuantity: {
      type: Number,
      required: true
    },
    fromDescription: {
      type: String,
      required: true
    },
    toDescription: {
      type: String,
      required: true
    }
  },
  methods: {
    round(value: number) {
      return roundToNDecimalPlaces(value, 2);
    }
  }
};
